<template>
  <span>
    <v-stepper-step :complete="getCurrentStep > step" :step="step">

      <slot name="title"></slot>

    </v-stepper-step>

    <v-stepper-content :step="step" :class="getCurrentStep>step?'complete':''">

      <slot name="content"></slot>

    </v-stepper-content>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {

    props: {
      step: {
        type: Number,
        default: 1
      },
    },

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep']),
    },

  }
</script>

<style lang="scss" scoped></style>
